import { builderLightText } from '@/legacy/blocks/utils'

import { BodyM, HeadingS } from '../Typography'

import type BlockTitlesProps from './types'

const BlockTitles = ({ title, subtitle, colorModifier, className }: BlockTitlesProps) => {
  const lightText = builderLightText(colorModifier)

  return (
    <div className={className}>
      {title && title.text && (
        <HeadingS light={lightText} className="eu-sm-1" tag={title.tag || 'h3'}>
          {title.text}
        </HeadingS>
      )}
      {subtitle && subtitle.text && (
        <BodyM light={lightText} className="eu-sm-2" tag={subtitle.tag || 'p'}>
          {subtitle.text}
        </BodyM>
      )}
    </div>
  )
}

export default BlockTitles
